"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/SpeakerNameBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _SoundAmplitude = require('web/components/VideoCall/SoundAmplitude'); var _SoundAmplitude2 = _interopRequireDefault(_SoundAmplitude);






const SpeakerNameBar = ({ audioTrack, name }) => (
  _react2.default.createElement('div', { className: "video-call--caller-name-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}
    , _react2.default.createElement('span', { className: "video-call--caller-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}},  name )
    /* nameSuffix &&
      <span className="video-call--caller-name-prefix">MD</span>
    */
    ,  audioTrack
      ? _react2.default.createElement(_SoundAmplitude2.default, {
          className: "video-call--caller-sound-amp",
          audioTrack: audioTrack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
        )
      : _react2.default.createElement('div', { className: "video-call--caller-mic-warn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
          , _react2.default.createElement('img', {
            src: "/assets/icons/video/mic-off-white-no-outline.svg",
            alt: "🔇", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
          )
        )
    
  )
)

exports. default = SpeakerNameBar
